import React from 'react';
import {PhysicianAndAccount,
        Account,
        AccountName,
        AccountId,
        Physician,
        PhysicianName,
        PhysicianId,
        AccountAndID,
        MoreItemView,
        SetsAndItemsValues,
        CounterInput,
        Status,
        StatusText,
        EAStatusText,
        EAStatus,
        NonTissue,
        Tissue,
        Flex
        } from '../SetsAndItems.styled'; 
import { useSelector } from 'react-redux';
import { 
    isMobileDevice, 
} from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import TissueItemIcon from 'src/assets/images/TissueItemIcon.svg';
import NonTissueItemIcon from 'src/assets/images/NonTissueItemIcon.svg'; 
import { GRAY_FONT_COLOR, SEMANTIC_TEXT_XSMALL_PX, X_SMALL_TEXT_PX } from '../../../../styles/fonts/MCFontConstants';

const Description = (props) => {
    const {
        isEquityOrder,
        isBundle,
        cartPage,
        showPhysicianAndAccountInsteadOfSetDetails,
        totalAccountCount,
        totalPhysicianCount,
        isEquity,
        isConsignmentAdd,
        accountName,
        accountId,
        accountsList,
        bom,
        cfn,
        productCFN,
        onSetItemClick,
        setOrItemDetails,
        physicianName,
        physicianId,
        isconsignmentAddOrder,
        setDescriptionMinWidth,
        mbHeight,
        mbWidth,
        reviewPage,
        templateDetails,
        isOrderDetail,
        setOrItemDetailsFontSizeDesktop,
        notes,
        setDetails,
        description,
        priceOverridePage,
        quantityValue,
        quantity,
        validateQuantity,
        productSearchFlag,
        isEquityProductGuide,
        bundleItems,
        isScheduleSurgery,
        salesOrg,
        isBundleSubItem,
        bundlePopUpFlag,
        subitem,
        uom,
        type,
        isProductTemplate,
        marginBottom,
        isEquityTemplate
    } = props;

    const { isCondensedView } = useSelector((state) => ({ 
        isCondensedView: state.loginReducer.isCondensedView,
    }));
    const { t } = useTranslation();

    const mobileDevice = isMobileDevice();
    return (
         <Flex justifyContent= 'space-between'
            marginTop= {isEquityOrder && !isBundle && cartPage? '6px' :
                isBundle? '10px':''}
            marginBottom= {isBundle? '4px':''}
        >
        {showPhysicianAndAccountInsteadOfSetDetails ? (
            <>
                {(totalAccountCount || totalPhysicianCount) && (
                    <PhysicianAndAccount className="PhysicianAndAccount">
                        {totalAccountCount && ( 
                            (isEquity || isConsignmentAdd) ? (
                                <>
                                    <Account
                                        flexDirection={'column'}
                                    >
                                        <AccountAndID>
                                            <AccountName className="common-account-dt-mask"
                                                truncate={
                                                    totalAccountCount -
                                                        2 >
                                                    0
                                                }
                                            >
                                                {accountName}
                                            </AccountName>
                                            <AccountId className="common-account-dt-mask">{`${accountId} `}</AccountId>
                                        </AccountAndID>
                                        <AccountAndID>
                                            {totalAccountCount - 1 >
                                                0 && (
                                                <>
                                                    <AccountName className="common-account-dt-mask"
                                                        truncate={
                                                            totalAccountCount -
                                                                2 >
                                                            0
                                                        }
                                                    >
                                                        {
                                                            accountsList[1]
                                                                .accountName
                                                        }
                                                    </AccountName>
                                                    <AccountId className="common-account-dt-mask">{`${accountId} `}</AccountId>
                                                    {totalAccountCount -
                                                        2 >
                                                        0 && (
                                                        <MoreItemView
                                                            id={`more-account-view-${ bom || cfn || productCFN
                                                            }`}
                                                            onClick={() =>
                                                                onSetItemClick(
                                                                    setOrItemDetails
                                                                )
                                                            }
                                                        >
                                                            {`+${
                                                                totalAccountCount -
                                                                2
                                                            }`}
                                                        </MoreItemView>
                                                    )}
                                                </>
                                            )}
                                        </AccountAndID>
                                    </Account>
                                </>
                            ) : (
                                <>
                                    <Account>
                                        <AccountName className="common-account-dt-mask"
                                            truncate={
                                                totalAccountCount -
                                                    1 >
                                                0
                                            }
                                        >
                                            {accountName}
                                        </AccountName>
                                        <AccountId className="common-account-dt-mask">{`${accountId} `}</AccountId>
                                        {totalAccountCount - 1 >
                                            0 && (
                                            <MoreItemView
                                                id= {`more-account-view-${totalAccountCount - 1 }`}
                                                onClick={() =>
                                                    onSetItemClick(
                                                        setOrItemDetails
                                                    )
                                                }
                                            >
                                                {`+${
                                                    totalAccountCount -
                                                    1
                                                } ${t(
                                                    'common.moreLabel'
                                                )}`}
                                            </MoreItemView>
                                        )}
                                    </Account>
                                </>
                            ))}
                        {totalPhysicianCount && (
                            <Physician>
                                <PhysicianName
                                    truncate={
                                        totalPhysicianCount - 1 > 0
                                    }
                                >
                                    {isEquity ? t('equity.common.bundleItems.dr') : isConsignmentAdd ? 
                                    t('ConsignmentAdd.common.setsAndItems.dr') 
                                    : t('common.drLabel')}{' '}<span className="common-physician-dt-mask">{physicianName}</span>
                                </PhysicianName>
                                <PhysicianId className="common-physician-dt-mask">
                                    {`${physicianId} `}
                                </PhysicianId>
                                {totalPhysicianCount - 1 > 0 && (
                                    <MoreItemView
                                    id = {`more-physician-view-${totalPhysicianCount - 1 }`}
                                        onClick={() =>
                                            onSetItemClick(
                                                setOrItemDetails
                                            )
                                        }
                                    >
                                        {`+${
                                            totalPhysicianCount - 1
                                        }` +
                                            ' ' +
                                            t('common.moreLabel')}
                                    </MoreItemView>
                                )}
                            </Physician>
                        )}
                    </PhysicianAndAccount>
                )}
            </>
        ) : (
            <SetsAndItemsValues
                width={isconsignmentAddOrder ? '80%' :
                    (isEquityOrder && cartPage) || isEquityTemplate? '70%': '95%'}
                minWidth={
                    setDescriptionMinWidth
                        ? setDescriptionMinWidth
                        : '200px'
                }
                mbWidth={isConsignmentAdd ? (reviewPage ? '100%' : '70%') : mbWidth}
                mbHeight={mbHeight}
                letterSpacing={'-0.11px'}
                mbMarginRight={'2rem'}
                marginRight={'22px'}
                style={{
                    textTransform: 'capitalize', 
                    borderRadius: templateDetails ? '6px' : null,
                    fontSize: templateDetails ? X_SMALL_TEXT_PX : null,
                    marginTop: (mobileDevice && isCondensedView && setOrItemDetails?.materialType == 'ZKMT') ? '-10px' 
                        : mobileDevice ? '0px' 
                        : templateDetails ? '10px' : '',
                    color: templateDetails && GRAY_FONT_COLOR,
                }}
                setOrItemDetailsFontSizeMobile={
                        isEquityOrder || (isBundle && isOrderDetail)
                            ? SEMANTIC_TEXT_XSMALL_PX
                            : setOrItemDetailsFontSizeDesktop 
                }
                opacity={isEquityOrder || isconsignmentAddOrder ? '0.7' : '1'} // added for equity
                setOrItemDetailsFontSizeDesktop={
                    setOrItemDetailsFontSizeDesktop
                }
                isEquityOrder={isEquityOrder}
                marginTop={isCondensedView && '0px'}
                marginBottom={marginBottom}
            >
                {notes ? setDetails || description : setDetails?.toLowerCase() || description?.toLowerCase()} 
            </SetsAndItemsValues>
        )}

        {priceOverridePage && (
            <CounterInput
                type="text"
                value={quantityValue}
                onChange={(e) => {
                    validateQuantity(e.target.value); 
                }}
                style={{ marginRight: '0px' }}
            ></CounterInput>)}

        { (isBundle && (!isOrderDetail || isEquityTemplate)) && (
                <Status marginTop={'3px'}>
                    <StatusText>
                        {isEquity || isEquityOrder ? t('equity.common.bundleItems.bundle') : 
                        isConsignmentAdd ? t('ConsignmentAdd.common.setsAndItems.bundle') : null}
                    </StatusText>
                </Status> )
        }

        {!productSearchFlag && !isOrderDetail &&
        (isEquityOrder && !cartPage && !isEquityProductGuide && !bundleItems && !isProductTemplate) && 
        !isConsignmentAdd && !isScheduleSurgery? (
                salesOrg == 'S030' ? (
                    <Tissue>
                        <img
                            src={TissueItemIcon}
                            alt="T"
                            style={{
                                height: '18px',
                                width: '24px',
                                marginLeft: '-9px',
                            }}
                        />
                    </Tissue>
                ) : salesOrg == 'S002' ? (
                    <NonTissue>
                        <img
                            src={NonTissueItemIcon}
                            alt="NT"
                            style={{
                                height: '18px',
                                width: '24px',
                                marginLeft: '-9px',
                            }}
                        />
                    </NonTissue>
                ) : null
            ) : null}
        {((subitem || bundlePopUpFlag) && !isConsignmentAdd && !isBundle && !isBundleSubItem) 
        || (isEquityOrder && cartPage && !isBundle)? (
            salesOrg == 'S030' ? (
                <Flex justifyContent='space-between'
                    minWidth='60px' width='auto'>
                    <Tissue marginLeft={'0px'}>
                        <img
                            src={TissueItemIcon}
                            alt="T"
                            style={{
                                height: '18px',
                                width: '24px',
                                marginLeft: '-9px',
                            }}
                        />
                    </Tissue>
                    <EAStatus style={{ marginTop: '10px' }}>
                        <EAStatusText>
                            {uom || type}
                        </EAStatusText>
                    </EAStatus>
                </Flex>
            ) : salesOrg == 'S002' ? (
                <Flex justifyContent='space-between' minWidth='60px' width='auto'>
                    <NonTissue marginLeft={'0px'}>
                        <img
                            src={NonTissueItemIcon}
                            alt="NT"
                            style={{
                                height: '18px',
                                width: '24px',
                                marginLeft: '-9px',
                            }}
                        />
                    </NonTissue>
                    <EAStatus style={{ marginTop: '10px' }}>
                        <EAStatusText>
                            {uom || type}
                        </EAStatusText>
                    </EAStatus>
                </Flex>
            ) : null
        ) : null}
        </Flex> 
    );
};

export default Description;